import { render } from "./UserGallery.vue?vue&type=template&id=4c8af294&scoped=true"
import script from "./UserGallery.vue?vue&type=script&lang=js"
export * from "./UserGallery.vue?vue&type=script&lang=js"

import "./UserGallery.vue?vue&type=style&index=0&id=4c8af294&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8af294"]])

export default __exports__